<template>
    <div>
        <template v-if="data.assignedStaffInitials">
            <span id="trigger" ref="trigger">{{ data.assignedStaffInitials }}</span>
            <b-popover :target="popoverTarget" triggers="hover" @show="onPopoverShow" placement="left" :boundary="getBoundary">
                <b-skeleton-wrapper :loading="!staffWorkItemAssignments">
                    <template #loading>
                        <b-skeleton></b-skeleton>
                        <b-skeleton></b-skeleton>
                        <b-skeleton></b-skeleton>
                    </template>

                    <b-list-group>
                        <b-list-group-item v-for="(staffWorkItemAssignment) in staffWorkItemAssignments" :key="staffWorkItemAssignment.staffWorkItemAssignmentId">
                            <div>{{ staffWorkItemAssignment.userAccountDisplayName }}</div>
                            <div v-if="!staffWorkItemAssignment.finalReactionDateTimeUTC && staffWorkItemAssignment.createdDateTimeUTC">Notified: {{ formatDateTime(staffWorkItemAssignment.createdDateTimeUTC, 'DD/MM/YYYY hh:mmA', true, false) }}</div>
                            <div v-if="staffWorkItemAssignment.status">Status: {{ staffWorkItemAssignment.status.displayName }}</div>
                            <div v-if="staffWorkItemAssignment.workItemRelatedRoles">Role/s: {{ staffWorkItemAssignment.workItemRelatedRoles.displayName }}</div>
                        </b-list-group-item>
                    </b-list-group>
                </b-skeleton-wrapper>
            </b-popover>
        </template>
    </div>
</template>

<script>

    import axios from 'axios';

    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import ErrorsMixin from '../../mixins/ErrorsMixin';

    
    export default {
        name: 'AssignedStaffColumnTemplate',
        mixins: [ErrorsMixin, DateTimeMixin],
        data: function () {
            return {
                data: null,
                staffWorkItemAssignments: null,
            };
        },

        computed: {

            getBoundary: function () {
                var boundary = document.getElementById('contentWrapper');
                return boundary;
            }
        },

        methods: {
           
            popoverTarget: function () {
                return this.$refs.trigger;
            },
            onPopoverShow: function () {
                if (this.staffWorkItemAssignments === null) {
                    this.loadStaffWorkItemAssignments();
                }
            },
            loadStaffWorkItemAssignments: function () {
                var url = this.$urlHelper.getApiUrl('staffworkitemassignment', 'byworkitem', [this.data.workItemId]);
                axios
                    .get(url)
                    .then(response => {
                        this.staffWorkItemAssignments = response.data;
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            }
        }
    }
</script>